"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var IconContext = /*#__PURE__*/(0, _react.createContext)({});
var _default = exports.default = IconContext;